/* 分享工具类 */
/* eslint-disable no-param-reassign,no-nested-ternary,no-useless-escape,quotes,space-infix-ops */
import i18n from 'react-intl-universal';

function openShareWindow(url, title, width = 600, height = 600) {
  if (!url) { return; }
  function x() {
    if (!window.open(url, title, `toolbar=0,resizable=1,scrollbars=yes,status=1,width=${width},height=${height}`)) {
      window.location.href = url;
    }
  }
  if (/Firefox/.test(navigator.userAgent)) { setTimeout(x, 0); } else { x(); }
}

export default function shareToSNS(sns, link, title, text = '', images = []) {
  const e = encodeURIComponent;

  link = e(`${link}?utm_campaign=maleskine&utm_content=note&utm_medium=writer_share&utm_source=${sns}`);

  if (title && title.length > 0) {
    title = title.replace(/\'|\"/g, "'");
  } else {
    title = '';
  }
  let shareUrl = '';
  title = e(title);
  const d = document;
  const s1 = window.getSelection;
  const s2 = d.getSelection;
  const s3 = d.selection;
  const s = s1 ? s1() : s2 ? s2() : s3 ? s3.createRange().text : '';
  switch (sns) {
    case 'weibo':
      shareUrl = `http://service.weibo.com/share/share.php?appkey=${process.env.WEIBO_ID}&
        title=${title}&url=${link}&searchPic=false&style=simple`;
      if (images.length > 0) { shareUrl += `&pic=${e(images[0])}`; }
      break;
    case 'douban':
      shareUrl = `http://www.douban.com/recommend/?url=${link}&title=${title}'&sel=${e(s)}&v=1&r=1`;
      break;
    case 'tweibo':
      shareUrl = `http://share.v.t.qq.com/index.php?c=share&a=index&url=${link}&title=${title}`;
      break;
    case 'qzone':
      shareUrl = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='${link}'&title=${title}`;
      break;
    case 'twitter':
      shareUrl = `https://twitter.com/share?url=${link}&text=${title}&related=jianshuio`;
      break;
    case 'facebook':
      shareUrl = `http://www.facebook.com/sharer.php?s=100&p[url]=${link}&p[title]=${title} ${i18n.get("share.trailing-jianshushe")}&p[summary]=${text||title}`;
      break;
    case 'google_plus':
      shareUrl = `https://plus.google.com/share?url=${link}`;
      break;
    default:
      break;
  }
  openShareWindow(shareUrl, title);
}



// WEBPACK FOOTER //
// ./src/utils/share.js